import React from 'react';

import { LuRefreshCw } from "react-icons/lu";

import { ButtonContainer } from './styles';

export default function SaveButton({ text, color, ...rest }) {
  return (
    <ButtonContainer type="button" {...rest} style={color ? {background: color} : {}}>
      <LuRefreshCw color="#fff" size={16} />
      <span>{text ? text : 'ATUALIZAR'}</span>
    </ButtonContainer>
  );
}
